export const getSpaceUrl = (entityId: string, shareKey?: string | null) => {
  const base = `/space/${entityId}`;
  return shareKey ? `${base}?shareKey=${shareKey}` : base;
};
